module.exports = __webpack_public_path__ + "img/logo_h5_white.f9bfdde1.png";